import { render, staticRenderFns } from "./ServiceFormDetail.vue?vue&type=template&id=4fb0b00b&scoped=true"
import script from "./ServiceFormDetail.vue?vue&type=script&lang=js"
export * from "./ServiceFormDetail.vue?vue&type=script&lang=js"
import style0 from "./ServiceFormDetail.vue?vue&type=style&index=0&id=4fb0b00b&prod&scoped=true&lang=css"
import style1 from "./ServiceFormDetail.vue?vue&type=style&index=1&id=4fb0b00b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb0b00b",
  null
  
)

export default component.exports